/**
 * Route for `advertiser-api-v2`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AdvertiserApiV2Page } from "../features/advertiser-api-v2/AdvertiserApiV2Page";

export const advertiserApiV2Route = createRoute({
	getParentRoute: () => rootRoute,
	path: "/advertiser-api-v2",
	component: AdvertiserApiV2Page,
});

export default advertiserApiV2Route;
